const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

// Сопоставление региона сделки с координатами по её адресу (та же логика,
// что determineRegion в src/containers/Productions/BackendProductions.js)
export const REGION_MAP = {
    "Санкт-Петербург": "СПБ",
    "Ленинградская область": "СПБ",
    "Москва": "МСК",
    "Московская область": "МСК",
    "Краснодар": "КРД",
    "Краснодарский край": "КРД",
};

export const REGION_COORDS = {
    СПБ: { lat: 59.9343, lon: 30.3351 },
    МСК: { lat: 55.7512, lon: 37.6184 },
    КРД: { lat: 45.0355, lon: 38.9753 },
};

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const resolveRegionFromCoordinates = async (latitude, longitude) => {
    try {
        const response = await fetch(`${PATH_TO_BACKEND}/api/geocode-region?lat=${latitude}&lon=${longitude}`);
        const data = await response.json();
        const regionFullName = data.regionFullName;
        if (!regionFullName) return null;
        if (REGION_MAP[regionFullName]) return REGION_MAP[regionFullName];

        let closest = null;
        let minDistance = Infinity;
        Object.entries(REGION_COORDS).forEach(([reg, coords]) => {
            const distance = calculateDistance(latitude, longitude, coords.lat, coords.lon);
            if (distance < minDistance) {
                minDistance = distance;
                closest = reg;
            }
        });
        return closest;
    } catch (error) {
        console.error("Ошибка геокодирования региона:", error);
        return null;
    }
};
